<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="PDM开单实时数据 center_1"
      :rightTitle="`${formatTime(
        this.dateData,
        'yyyy-MM-dd'
      )} 合计：${total_money}`"
      :tooltipText="'开单提交实时金额数据，不含本厂责任售后'"
    ></chart-title>
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
      <div class="two_col" slot="main">
        <div id="center_1" />
        <div class="center_1_bottom">
          <dv-scroll-board
            @click="handleDetail"
            :config="config"
            style="width: 100%; height: 95%; margin-top: 10px"
          />
        </div>
      </div>
    </date-change-card>
  </div>
</template>

<script>
import { distributionData } from "@/api/cockpit/jyl";
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
import { formatTime, getNextDate, arrDataFormat } from "@/utils/index";
export default {
  mixins: [resize],
  name: "center_1",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      chart: null,
      total_money: 0,
      chartData: [],
      dateData: new Date(),
      config: {
        rowNum: 3,
        headerBGC: "transparent", // 表头背景色
        oddRowBGC: "transparent", // 奇数行背景色
        evenRowBGC: "transparent", // 偶数行背景色
        waitTime: 2000, // 轮播时间间隔(ms)
        align: [
          "center",
          "center",
          "center",
          "center",
          "center",
          "center",
          "center",
          "center",
        ],
        columnWidth: [80],
        data: [],
      },
    };
  },
  props: {},
  created() {},
  mounted() {
    this.getData();
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    formatTime,
    getData() {
      distributionData({
        add_time: formatTime(this.dateData, "yyyy-MM-dd"),
        type: "now",
      }).then((resp) => {
        let scrollData = [];
        if (resp.data.list["滚动"]) {
          resp.data.list["滚动"].forEach((m) => {
            scrollData.push([
              `<span style="color:#409EFF">开单啦！</span>`,
              `<span style="color:#409EFF">${m.platform} ${m.time}</span>`,
              `<span style="color:#409EFF">${m.aNameCode}</span>`,
              `<span style="color:#409EFF">${m.c_name}</span>`,
              `<span style="color:#409EFF">${m.type_name}</span>`,
              `<span style="color:#409EFF">${m.goods}</span>`,
              `<span style="color:#409EFF">金额 ${m.gc_gold}</span>`,
            ]);
          });
        }
        this.config.data = scrollData;
        this.config = { ...this.config };
        this.chartData = arrDataFormat(resp.data.list);
        this.total_money = resp.data.total_money;
        this.initChart();
      });
    },
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("center_1"));
      this.setOptions();
    },
    setOptions() {
      if (!this.chartData || !this.chartData.length) {
        this.chart.dispose();
        this.chart = null;
        return;
      }
      this.chart.setOption({
        color: ["#009dff", "#22e4ff", "#3bffd0"],
        tooltip: {
          trigger: "item",
        },
        title: [
          {
            subtext: this.chartData[0].name,
            left: "16%",
            bottom: "27%",
            textAlign: "center",
            subtextStyle: {
              color: "#C0C4CC",
              fontSize: "14",
              fontWeight: "bold",
            },
          },
          {
            subtext: this.chartData[1].name,
            left: "50%",
            top: "9%",
            textAlign: "center",
            subtextStyle: {
              color: "#C0C4CC",
              fontSize: "14",
              fontWeight: "bold",
            },
          },
          {
            subtext: this.chartData[2].name,
            left: "83.33%",
            bottom: "27%",
            textAlign: "center",
            subtextStyle: {
              color: "#C0C4CC",
              fontSize: "14",
              fontWeight: "bold",
            },
          },
        ],
        legend: {
          orient: "horizontal",
          center: "center",
          bottom: "6%",
          textAlign: "center",
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        series: [
          {
            type: "pie",
            radius: ["15%", "30%"],
            center: ["50%", "32%"],
            data: arrDataFormat(this.chartData[0].value),
            label: {
              // position: "outer",
              // alignTo: "none",
              // bleedMargin: 5,
              formatter: "{b}：\n {@2012}",

              color: "#C0C4CC",
            },
            labelLine: {
              length: 1,
            },
            left: 0,
            right: "66.6667%",
            top: 0,
            bottom: 0,
          },
          {
            type: "pie",
            radius: ["15%", "30%"],
            center: ["50%", "52%"],
            data: arrDataFormat(this.chartData[1].value),
            label: {
              position: "outer",
              alignTo: "none",
              bleedMargin: 5,
              formatter: "{b}：\n {@2012}",

              color: "#C0C4CC",
            },
            labelLine: {
              length: 1,
            },
            left: "35%",
            right: "33.3333%",
            top: 0,
            bottom: 0,
          },
          {
            type: "pie",
            radius: ["15%", "30%"],
            center: ["50%", "32%"],
            data: arrDataFormat(this.chartData[2].value),
            label: {
              position: "outer",
              alignTo: "none",
              bleedMargin: 5,
              formatter: "{b}：\n {@2012}",

              color: "#C0C4CC",
            },
            labelLine: {
              length: 1,
            },
            left: "68%",
            right: 0,
            top: 0,
            bottom: 0,
          },
        ],
      });
    },
    //前一日
    leftClick() {
      this.dateData = getNextDate(formatTime(this.dateData, "yyyy-MM-dd"), -1);
      this.getData();
    },
    //后一日
    rightClick() {
      this.dateData = getNextDate(formatTime(this.dateData, "yyyy-MM-dd"), +1);
      this.getData();
    },
    handleDetail() {
      window.open(
        `${process.env.VUE_APP_SP_URL}/#/login?nameJSC=平台订单统计&username=${
          process.env.VUE_APP_NAME_PDM
        }&password=${process.env.VUE_APP_PASS}&tg_time_range=${formatTime(
          this.dateData,
          "yyyy-MM-dd"
        )}`,
        "_blank"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 40vh;
  .two_col {
    padding: 0 10px;
    height: 100%;
    #center_1 {
      height: 76%;
    }
    .center_1_bottom {
      height: 22%;
    }
  }
}
</style>
